import { Component, OnInit, Input, OnDestroy, SecurityContext } from '@angular/core';
import { AlertAndNotificationsService } from 'src/app/core/services/alert-and-notifications.service';
import { AuthService } from 'src/app/core/services/auth.service';
import { CompanyService } from 'src/app/core/services/company.service';
import { JobMatchService } from 'src/app/core/services/job-match.service';
import { StorageService } from 'src/app/core/services/storage.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-view-assessment-report',
  templateUrl: './view-assessment-report.component.html',
  styleUrls: ['./view-assessment-report.component.css']
})
export class ViewAssessmentReportComponent implements OnInit, OnDestroy {

  @Input() jobMatchId;
  @Input() testInvitationId;
  @Input() assessmentType;
  @Input() isSectionalReport;
  @Input() context;

  availabilityDate: any;
  availabilityObject: any = {};
  jobMatch: any = {};
  companyId: any;
  url: SafeResourceUrl;
  embedUrl: SafeResourceUrl;
  reportTitle: any;
  reportGenerating: boolean = false;
  reportError: boolean = false;
  _pdfBlobUrl: string;

  loadingFlag: boolean = false;
  reportLoadingFlag: boolean = true;
  isStaffingCompany: boolean;


  constructor(
    private authService: AuthService,
    private companyService: CompanyService,
    private jobMatchService: JobMatchService,
    private alertsAndNotificationsService: AlertAndNotificationsService,
    private sanitizer: DomSanitizer,
    private storageService: StorageService
  ) {
    // initialize to a safe resource URL so Angular's RESOURCE_URL sanitizer
    // doesn't throw when template binds before the endpoint response arrives
    this.embedUrl = this.getSafeUrl('about:blank');
    this.url = this.getSafeUrl('about:blank');
  }

  ngOnInit() {
    this.companyId = this.authService.getUserDetails().company.companyId;
    this.reportTitle = this.assessmentType == 'Technical' ? 'Technical Assessment Report' : 'Value Assessment Report';

    //flags
    this.loadingFlag = true;
    this.reportLoadingFlag = true;
    this.isStaffingCompany = this.companyService.isStaffingCompany();

    this._getJobMatchCardInfo();
  }
  
  _getJobMatchCardInfo() {
    this.loadingFlag = true;
    this.reportLoadingFlag = true;
    this.jobMatchService.getCandidateJobMatchCard(this.jobMatchId, this.companyId, (data) => {
      this.jobMatch = data;
      this.jobMatch.name = this.jobMatch.firstName + ' ' + this.jobMatch.lastName;
      this._getReport();
      this.loadingFlag = false;
      setTimeout(() => {
        this.reportLoadingFlag = false;
      }, 3000);
    }, (error) => {
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    }, undefined);

  }

  _getReport() {
    if (this.isSectionalReport == undefined && this.context == "notification") {
      this.isSectionalReport = this.isStaffingCompany && this.jobMatch.isSharedRequisition;
    }

    this.reportLoadingFlag = true;
    this.reportGenerating = false;
    this.reportError = false;

    this.jobMatchService.getCandidatePdfReport(this.testInvitationId, this.isSectionalReport, (blob: Blob) => {
      if (blob.type.indexOf('application/pdf') !== -1) {
        this._showPdf(blob);
        return;
      }

      // Anything other than a PDF means the report is not ready yet
      this._readBlobText(blob, (text) => {
        let hasData = false;
        try {
          const json = text && text.length ? JSON.parse(text) : null;
          hasData = !!(json && (json.filepath || json.fileName || json.data));
        } catch (e) {
          hasData = false;
        }
        if (hasData) {
          const endpoint = this.storageService.get('baseurl') + 'api/candidate/candidatepdfreport?testinvitationid='
            + this.testInvitationId + '&sectional=' + this.isSectionalReport;
          this.embedUrl = this.getSafeUrl(endpoint + '#view=fitH');
          this.url = this.getSafeUrl(endpoint);
        } else {
          this.reportGenerating = true;
        }
        this.reportLoadingFlag = false;
      });
    }, () => {
      this.embedUrl = this.getSafeUrl('about:blank');
      this.url = this.getSafeUrl('about:blank');
      // a real HTTP failure (4xx/5xx) is not the same as "report not ready yet" -
      // don't tell the user to wait for something that already failed
      this.reportError = true;
      this.reportLoadingFlag = false;
    });
  }

  private _showPdf(blob: Blob) {
    this._revokePdfBlobUrl();
    this._pdfBlobUrl = URL.createObjectURL(blob);
    this.embedUrl = this.getSafeUrl(this._pdfBlobUrl + '#view=fitH');
    this.url = this.getSafeUrl(this._pdfBlobUrl);
    this.reportLoadingFlag = false;
  }

  private _readBlobText(blob: Blob, callback: (text: string) => void) {
    const reader = new FileReader();
    reader.onload = () => callback(reader.result as string);
    reader.onerror = () => callback('');
    reader.readAsText(blob);
  }

  private _revokePdfBlobUrl() {
    if (this._pdfBlobUrl) {
      URL.revokeObjectURL(this._pdfBlobUrl);
      this._pdfBlobUrl = undefined;
    }
  }

  ngOnDestroy() {
    this._revokePdfBlobUrl();
  }

  getSafeUrl(url: string): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

}
